import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1.5fr repeat(6, 1fr) 0.1fr;

  padding: 0 15px;
  cursor: pointer;
  user-select: none;

  align-items: center;
  height: 59px;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;

    gap: 10px;
  }

  h4 {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;

    color: #808b9f;
  }
`;

export const Name = styled.div`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;

  /* 1 */

  color: #4a5e83;
`;

type EspecieProps = { textColor: string };
export const Especie = styled.div<EspecieProps>`
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: left;
  background: ${(props) => props.color};
  opacity: 0.8;
  border-radius: 100px;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  /* identical to box height */

  /* 5 */

  color: ${(props) => props.textColor};
`;

export const TextResult = styled.div`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;

  color: ${(props) => props.color};
`;
